export enum NotificationTypeEnum {
  INFO = 'info',
  ISSUE = 'issue',
  NEUTRAL = 'neutral',
}

export type NotificationType =
  | NotificationTypeEnum.INFO
  | NotificationTypeEnum.ISSUE
  | NotificationTypeEnum.NEUTRAL;
